import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { OrderService } from "../../services/order-service";
import { UserFormsServiceProxy, UserFormOrderFormTypeDto } from "../../../../../../../shared/service-proxies/service-proxies";
import { Router, ActivatedRoute } from "@angular/router";
import { TestService } from '../../../../../../../test/service/test.service';
import { BehaviorSubject } from 'rxjs';
import { CustomLocalizationService } from '../../../utility/customLocalization.service';



@Component({
	selector: "kt-step2",
	templateUrl: "./step2.component.html",
	styleUrls: ["./step2.component.scss"],
})
export class Step2Component implements OnInit{
	
	cardId : number;
	formCards = new BehaviorSubject<UserFormOrderFormTypeDto[]>([]);

	constructor(
		private _testService: TestService,
		private orderService: OrderService,
		private router: Router,
		private route: ActivatedRoute,

		private _userFormService: UserFormsServiceProxy,
		private customLocalization: CustomLocalizationService

	) {
	

	}
	

	ngOnInit() {

		var orderDataObj = null;

		console.log("Step 2'deyim gelsene.");

		this.cardId = +this.route.snapshot.paramMap.get('id');

		this._userFormService.getFormCardsByOrderCardId(this.cardId)
				.subscribe(result => {

					this.formCards.next(result);

				});
		
				//Yukarıda seçili olan cardın title ve subtitle tutmak için içerisinde session tutuyoruz.
				//this.orderService.cardTitleAndSubTitleStep2.subscribe(result => {

				//	console.log("STEP TİTLE VE SUBTİTLE DEGERLERİ:	" + titleAndSubtitleObj);
				//	var titleAndSubtitleObj = this.orderService.getOrderTitleAndSubtitleWithSession(result, "cardTitleAndSubTitleObjStep2");

				//	//card kısmının üzerinde bulunğu talep tipine ait başlık ve alt başlık bilgilerini basar.
				//	this._testService.setTitle(titleAndSubtitleObj.title);
				//	this._testService.setDesc(titleAndSubtitleObj.subtitle);

				//})

		if (this.cardId == 1) {
			this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TOMAINWAREHOUSE.HEADER"));
			this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TOMAINWAREHOUSE.SUBHEADER"));
		}

		else if (this.cardId == 2) {
			this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TOREGIONWAREHOUSE.HEADER"));
			this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TOREGIONWAREHOUSE.SUBHEADER"));		}

		else if (this.cardId == 3) {
			this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.FROMRECEIVEWAREHOUSE.HEADER"));
			this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.FROMRECEIVEWAREHOUSE.SUBHEADER"));
		}

		else if (this.cardId == 4) {
			this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TRANSFER.HEADER"));
			this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TRANSFER.SUBHEADER"));
		}
		
	
	}

	btnGoToNextStep(cardId : number){

		//var selectCardObj = this.formCards.getValue().find(x => x.id == cardId);

		//if(selectCardObj){
		//	this.orderService.cardTitleAndSubTitleStep3.next({title: selectCardObj.title, subTitle: selectCardObj.subTitle});

		//}

		this.router.navigate(['../../step3/', cardId], { relativeTo: this.route });

	}
	
	ngOnDestroy(): void {
		this._testService.setTitle(" ");
		this._testService.setDesc(" ");
		//this.orderService.cardTitleAndSubTitle.unsubscribe();
	}
	

}
